import useDownloadFile from 'components/ShareDocument/SharePreviewContent/useDownloadFile';

interface SharePreviewDownloadButtonProps {
  url: string;
  filename?: string;
}

const SharePreviewDownloadButton = ({ url, filename }: SharePreviewDownloadButtonProps) => {
  const { isDownloading, downloadFile } = useDownloadFile(url, filename);

  return (
    <button
      type='button'
      className='general-button d-flex align-items-center border specific-x-padding-12 specific-y-padding-8 specific-top-padding-lg-4 specific-bottom-padding-lg-5  specific-left-padding-lg-15 specific-right-padding-lg-18 rounded-pill hovered-button bg-main-white paragraph-p3 share-preview-controls-download'
      disabled={isDownloading}
      onClick={downloadFile}
    >
      {isDownloading ? (
        <i className='fas fa-spinner fa-spin specific-right-margin-12' />
      ) : (
        <span className='icon-download-attachment paragraph-p5 specific-right-margin-lg-12 d-inline-block-centered specific-top-margin-1' />
      )}
      <span className='d-none d-lg-inline-block'>Download</span>
    </button>
  );
};

export default SharePreviewDownloadButton;
